import React from 'react';
import InvoicesTable from "./InvoicesTable";

const Invoices = () => {
    return (
        <div className="invoice-container">
            <InvoicesTable/>
        </div>
    );
};

export default Invoices;